@if (showSkeleton()) {
<div class="skeleton">
  <div class="skeleton__header">
    <div class="skeleton__bar skeleton__bar--name"></div>
    <div class="skeleton__header-icons">
      <div class="skeleton__circle"></div>
    </div>
  </div>
  <div class="skeleton__body">
    <div class="skeleton__square"></div>
    <div class="skeleton__body-lines">
      <div class="skeleton__bar skeleton__bar--update"></div>
      <div class="skeleton__bar skeleton__bar--address"></div>
      <div class="skeleton__bar skeleton__bar--address-short"></div>
    </div>
  </div>
</div>
} @else {
<div class="vehicle-status-item__vehicle-header">
  <div>
    <div class="vehicle-status-item__vehicle-header__top-row">
      <h4 [fmTooltip]="asset.name" [showTooltipIfOverflow]="true" class="vehicle-status-item__vehicle-header__top-row__name">
        {{ asset.name }}
      </h4>
      <mat-icon
        *ngIf="vehicleStatusInfo?.showHealthStatus && checkVehicleHealthIssue()"
        svgIcon="ic-health-status-critical"
        fmTooltip
        [fmTooltipTemplate]="vehicleDeviceHealthStatusToolTip"
        class="vehicle-status-item__vehicle-header__top-row__health-status-icon"
        a7s-id="live-map-vehicle-issue-badge-icon-hover"
      >
      </mat-icon>
    </div>
  </div>
  <div class="vehicle-status-item__vehicle-header-menu">
    <mat-icon
      a7s-id="vehicle-panel-header-asset-context-menu"
      class="vehicle-status-item__vehicle-header-menu-icon vehicle-status-item__vehicle-header-menu-context mat-icon-size-xs"
      svgIcon="ds-ic-elipsis"
      (click)="openVehicleContextMenuClick($event)"
    ></mat-icon>
  </div>
</div>
<div class="vehicle-status-item-body-container">
  <div class="vehicle-status-item__vehicle-body">
    <mat-icon [svgIcon]="'ic-' + asset.iconClass" class="vehicle-status-item__vehicle-body-icon mat-icon-size-xs"></mat-icon>
    <div class="vehicle-status-item__vehicle-body-text-container">
      <p class="vehicle-status-item__vehicle-body-last-update-text">
        <span i18n="@@S_LAST_UPDATE">Last Update:</span> {{ asset.lastUpdate }}
      </p>
      <p *ngIf="asset.address" class="vehicle-status-item__vehicle-body-address">{{ asset.address }}</p>
    </div>
  </div>
</div>
<ng-template #vehicleDeviceHealthStatusToolTip>
  <div class="health-status-tooltip-container">
    <fm-health-status-tooltip
      [deviceHealthStatus]="this.vehicleHealthStatus?.healthStatus ?? ''"
      [deviceType]="EPlotType.asset"
    ></fm-health-status-tooltip>
  </div>
</ng-template>
}
